import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ModelTableCheckedItem, ModelTableOptionSelected, ModelTableOptionSelectedDelete, ModelTableOptionSelectedPause, ModelTableOptionSelectedResume } from './models';

@Component({
  selector: 'app-basic-table',
  host: { class: "tdw-table" },
  encapsulation: ViewEncapsulation.None,
  templateUrl: './basic-table.component.html',
  styleUrls: ['./basic-table.component.scss']
})
export class BasicTableComponent {
  _mDirectEdit: boolean = false;
  _isAuditLog: boolean = false;
  _mToggleStatus: boolean = false;
  toggleStatus: boolean = true;
  _mIsView: boolean = false;
  _mIsReply: boolean = false;
  _mPause: boolean = false;
  _mResume: boolean = false;
  _mDelete: boolean = false;
  mSelectedOption: string;
  _mIsPauseData: any[] = [];
  _mIsResumeData: any[] = [];
  _mIsDeleteData: any[] = [];

  @Input() columnHeaders: any[];
  @Input() tableData: any[];

  @Input("toggleStatus") set toggleStatusM(status: boolean) {
    this._mToggleStatus = status;
  }

  @Input("subcribeEdit") set edit(status: boolean) {
    this._mDirectEdit = status;
  }

  @Input("isAuditLog") set isAuditLog(status: boolean) {
    this._isAuditLog = status;
  }

  @Input("isReply") set isReply(status: boolean) {
    this._mIsReply = status;
  }

  @Input() public isEditIcon: boolean;

  @Output("onStatusChanged")
  mOnStatusChanged = new EventEmitter<ModelTableOptionSelected>();

  @Output("onEditIconClicked")
  mOnEditIconClicked = new EventEmitter<ModelTableOptionSelected>();

  @Output("onAuditLog")
  mOnAuditLog = new EventEmitter<ModelTableOptionSelected>();

  @Output("pause")
  mPause = new EventEmitter<ModelTableOptionSelectedPause>();

  @Output("resume")
  mResume = new EventEmitter<ModelTableOptionSelectedResume>();

  @Output("delete")
  mDelete = new EventEmitter<ModelTableOptionSelectedDelete>();

  @Output("onReplyIconClicked")
  mOnReplyLog = new EventEmitter<ModelTableOptionSelected>();

  constructor() { }

  ngOnInit(): void {
  }

  statusToggle(data) {
    let index = this.tableData.indexOf(data);
    let option = new ModelTableOptionSelected(index, data);
    this.mOnStatusChanged.emit(option);
  }

  onEditIconClicked(item: any) {
    let index = this.tableData.indexOf(item);
    let option = new ModelTableOptionSelected(index, item);
    this.mOnEditIconClicked.emit(option);
  }

  onAuditLogClicked(item: any) {
    let index = this.tableData.indexOf(item);
    let option = new ModelTableOptionSelected(index, item);
    this.mOnAuditLog.emit(option);
  }

  _mIsCheckable: boolean = false;
  _mIsCheckedList: boolean[] = [];
  _mDataRaw: any[];
  _mIsAllChecked: boolean = false;
  mIsOptionSelected: boolean;
  @Output("onCheckChangeAll")
  mOnCheckChangeAll = new EventEmitter<boolean>();

  @Output("onCheckChangeItem")
  mOnCheckChangeItem = new EventEmitter<ModelTableCheckedItem>();

  @Output("onItemOptionSelected")
  mOnItemOptionSelected = new EventEmitter<ModelTableOptionSelected>();

  @Input() set isPause(val: boolean) {
    this._mPause = val;
    if (this._mPause && this._mDataRaw) {
      this._mIsPauseData = [];
      this._mDataRaw.forEach(element => {
        this._mIsPauseData.push(element);
      });
    }
  }

  @Input() set isResume(val: boolean) {
    this._mResume = val;
    if (this._mResume && this._mDataRaw) {
      this._mIsResumeData = [];
      this._mDataRaw.forEach(element => {
        this._mIsResumeData.push(element);
      });
    }
  }

  @Input() set isDelete(val: boolean) {
    this._mDelete = val;
    if (this._mDelete && this._mDataRaw) {
      this._mIsDeleteData = [];
      this._mDataRaw.forEach(element => {
        this._mIsDeleteData.push(element);
      });
    }
  }

  @Input("data") set data(data: any[]) {
    if (!data) {
      return;
    }
    if (this._mIsCheckable) {
      if (data === this._mDataRaw) {
        //return;
      } else {
        this._mIsCheckedList = [];
      }
      data.forEach(element => {
        this._mIsCheckedList.push(false);
      });
    }
    this._mDataRaw = data;
  }

  @Input("isCheckable") set isCheckable(val: boolean) {
    this._mIsCheckable = val;
    if (this._mIsCheckable && this._mDataRaw) {
      this._mIsCheckedList = [];
      this._mDataRaw.forEach(element => {
        this._mIsCheckedList.push(false);
      });
    }
  }

  setItemChecked(index: number, isChecked: boolean) {
    if (this._mIsCheckable) {
      this._mIsCheckedList[index] = isChecked;
      if (isChecked === false && this._mIsAllChecked == true) {
        this._mIsAllChecked = false;
      }
    }
  }

  getIndex(item) {
    let index = this.tableData.indexOf(item);
    return index;
  }

  onOptionMenuClosed(item: any) {
    let index = this.tableData.indexOf(item);
    if (this.mIsOptionSelected) {
      let option = new ModelTableOptionSelected(index, item);
      this.mIsOptionSelected = false;
      this.mOnItemOptionSelected.emit(option);
    }
  }

  onUpdateCheckAll($event) {
    for (let i = 0; i < this._mIsCheckedList.length; i++) {
      this._mIsCheckedList[i] = $event.checked;
    }
    this._mIsAllChecked = $event.checked;
    this.mOnCheckChangeAll.emit($event.checked);
  }

  onUpdateCheckItem($event, item: any) {
    let index = this.tableData.indexOf(item);
    if (index < 0) {
      return;
    }
    this._mIsCheckedList[index] = $event.checked;
    this.mOnCheckChangeItem.emit(new ModelTableCheckedItem(index, $event.checked, this._mDataRaw[index]));
  }

  onPause(item: any) {
    let index = this.tableData.indexOf(item);
    let option = new ModelTableOptionSelectedPause(index, item, this.tableData[index]);
    this.mPause.emit(option);
  }

  onResume($event, item: any) {
    let index = this.tableData.indexOf(item);
    let option = new ModelTableOptionSelectedResume(index, this._mDataRaw[index]);
    this.mResume.emit(option);
  }

  onDelete(item: any) {
    let index = this.tableData.indexOf(item);
    let option = new ModelTableOptionSelectedDelete(index, this.tableData[index]);
    this.mDelete.emit(option);
  }

  onReplyIconClicked(item: any) {
    let index = this.tableData.indexOf(item);
    let option = new ModelTableOptionSelected(index, this.mSelectedOption);
    this.mOnReplyLog.emit(option);
  }

  getTitle(key, item) {
    if (key == 'action') {
      return '';
    } else if (key == 'recipientRoles') {
      if (item[key].items.length > 0) {
        return item[key].items.map(ele => {
          return ele.value
        }).join(', ');
      } else {
        return '';
      }
    } else if (key == 'bcc_Roles') {
      if (item[key].items.length > 0) {
        return item[key].items.map(ele => {
          return ele.value
        }).join(', ');
      } else {
        return '';
      }
    } else if (key == 'ccRoles') {
      if (item[key].items.length > 0) {
        return item[key].items.map(ele => {
          return ele.value
        }).join(', ');
      } else {
        return '';
      }
    } else if (key == 'menus') {
      if (item[key].items.length > 0) {
        return item[key].items.map(ele => {
          return ele.value
        }).join(', ');
      } else {
        return '';
      }
    } else {
      return item[key];
    }
  }

}
